import { sessionStorage } from './sessionStorage';

/**
* Check if localStorage is accessible
* @returns {boolean}
*/
const isLocalStorageEnabled = () => {
  try {
    window.localStorage.setItem('$test', '$test');
    window.localStorage.removeItem('$test');
    return true;
  } catch (e) {
    return false;
  }
};

const localStorage = {};
const sessionStorageObject = sessionStorage.create();

/**
* Get the key name from localStorage by index
* @param {Number} index number of the key
* @returns {String|undefined} returns the localStorage key or undefined
*/
const key = (index) => {
  try {
    return window.localStorage.key(index);
  } catch (e) {
    // Storage is full or disabled due to private browsing mode (Safari).
    return undefined;
  }
};

/**
* Get the localStorage item value for key k
* @param {String} k key
* @returns {Object|undefined} returns the localStorage key value or undefined
*/
const get = (k) => {
  try {
    const value = window.localStorage.getItem(k);
    if (!(typeof value === 'string' || value instanceof String)) {
      return undefined;
    }

    return JSON.parse(value);
  } catch (e) {
    // Bad JSON or storage is broken.
    return undefined;
  }
};

/**
* Set key->value to localStorage
* @param {String} k key
* @param {Object} value value
*/
const set = (k, value) => {
  try {
    window.localStorage.setItem(k, JSON.stringify(value));
  } catch (e) {
    // Storage is full or disabled due to private browsing mode (Safari).
  }
};

/**
* Delete item in localStorage by key
* @param {String} k key
*/
const del = (k) => {
  try {
    window.localStorage.removeItem(k);
  } catch (e) {
    // Storage is full or disabled due to private browsing mode (Safari).
  }
};

/**
* Remove all localStorage elements
*/
const clear = () => {
  try {
    window.localStorage.clear();
  } catch (e) {
    // Storage is full or disabled due to private browsing mode (Safari).
  }
};

if (isLocalStorageEnabled) {
  localStorage.key = key;
  localStorage.get = get;
  localStorage.set = set;
  localStorage.del = del;
  localStorage.clear = clear;

  Object.defineProperty(localStorage, 'length', {
    get() {
      try {
        return window.localStorage.length;
      } catch (e) {
        // Storage is full or disabled due to private browsing mode (Safari).
        return 0;
      }
    },
    configurable: false,
    enumerable: false,
  });
}

localStorage.isPersistent = () => isLocalStorageEnabled;
sessionStorageObject.isPersistent = () => isLocalStorageEnabled;

// if isLocalStorageEnabled is enabled export the localStorage otherwise export sessionStorage
export const storage = isLocalStorageEnabled ? localStorage : sessionStorageObject;
